import React, { FC } from 'react';
import Badge from '@material-ui/core/Badge';
import styled from 'styled-components';
import { SystemIconButton } from '../../../Icon/SystemIconButton';
import { useDataTableFilterContext } from '../../utils/DataTableFilterContext';
import { useIntlUds } from '../../../../translations/UdsIntlProvider';

export const DataTableFilterIcon: FC<React.PropsWithChildren<unknown>> = () => {
  const { intl } = useIntlUds();
  const { setOpenFilterDrawer, hasFilters, hiddenVariables, activeFilters } = useDataTableFilterContext();

  if (!hasFilters) return null;

  const hasSelectedFilters = hiddenVariables?.length
    ? activeFilters?.filter((filter) => !hiddenVariables.includes(filter.id)).length > 0
    : activeFilters.length > 0;

  const activeFiltersLength = activeFilters.length ?? 0;

  return (
    <StyledBadge badgeContent={activeFiltersLength} color="primary">
      <SystemIconButton
        color={hasSelectedFilters ? 'active' : undefined}
        dataTest="data-table-filter-icon"
        iconName="filter_list"
        tooltipText={intl.DataTable.Filters.filtersLabel}
        className={hasSelectedFilters ? 'active' : undefined}
        onClick={() => setOpenFilterDrawer(true)}
      />
    </StyledBadge>
  );
};

const StyledBadge = styled(Badge)`
  .MuiBadge-anchorOriginTopRightRectangle {
    transform: scale(1) translate(18%, 13%);
    pointer-events: none;
  }
`;
